import { render, staticRenderFns } from "./ReviewListIframe.vue?vue&type=template&id=8970b080&"
import script from "./ReviewListIframe.vue?vue&type=script&lang=ts&"
export * from "./ReviewListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports